import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const FooterWrapper = styled.footer`
  background: linear-gradient(135deg, rgb(49, 110, 177) 0%, rgb(78, 158, 163) 100%);
  color: white;
  padding: 50px 20px 30px;
  margin-top: 60px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
`;

const FooterContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  gap: 40px;
  justify-content: space-between;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 30px;
  }
`;

const FooterColumn = styled.div`
  flex: 1;
  min-width: 220px;
`;

const FooterTitle = styled.h4`
  margin-bottom: 20px;
  font-size: 1.2rem;
  color: white;
  font-weight: 600;
  border-bottom: 2px solid rgba(255, 255, 255, 0.3);
  padding-bottom: 8px;
`;

const FooterText = styled.p`
  margin: 0 0 12px;
  font-size: 0.95rem;
  line-height: 1.6;
  opacity: 0.9;
`;

const StyledFooterLink = styled(Link)`
  display: block;
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
  margin-bottom: 8px;
  font-size: 0.95rem;
  transition: all 0.3s ease;
  padding: 4px 0;
  border-radius: 4px;

  &:hover {
    color: white;
    transform: translateX(5px);
    background: rgba(255, 255, 255, 0.1);
    padding-left: 8px;
  }
`;

const FooterBottom = styled.div`
  margin-top: 50px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  padding-top: 20px;
  text-align: center;
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.8);
`;

const ContactInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const ContactItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  opacity: 0.9;
  
  &:before {
    content: "•";
    color: rgba(255, 255, 255, 0.7);
    font-weight: bold;
  }
`;

export default function Footer() {
  return (
    <FooterWrapper>
      <FooterContainer>
        <FooterColumn>
          <FooterTitle>Genion Quantum Technologies</FooterTitle>
          <FooterText>
            Revolutionizing Pharmaceutical Research with AI and Quantum Computing.
          </FooterText>
          <FooterText style={{ opacity: 0.8, fontStyle: 'italic' }}>
            Pioneering the future of drug discovery through advanced artificial intelligence
            and quantum mechanics integration.
          </FooterText>
        </FooterColumn>

        <FooterColumn>
          <FooterTitle>Quick Links</FooterTitle>
          <StyledFooterLink to="/partnership">Partnership</StyledFooterLink>
          <StyledFooterLink to="/membership">Pricing</StyledFooterLink>
          <StyledFooterLink to="/company-overview">About</StyledFooterLink>
          <StyledFooterLink to="/contact">Contact</StyledFooterLink>
        </FooterColumn>

        <FooterColumn>
          <FooterTitle>Contact Information</FooterTitle>
          <ContactInfo>
            <ContactItem>Maryland, United States</ContactItem>
            <ContactItem>Phone: 240-686-5707</ContactItem>
            <ContactItem>Email: <a href="mailto:genionquantumtech@gmail.com" style={{ color: 'white', textDecoration: 'underline' }}>genionquantumtech@gmail.com</a></ContactItem>
          </ContactInfo>
        </FooterColumn>

        <FooterColumn>
          <FooterTitle>Our Services</FooterTitle>
          <StyledFooterLink to="/services">AI-Driven Drug Design</StyledFooterLink>
          <StyledFooterLink to="/services">Quantum Computing Solutions</StyledFooterLink>
          <StyledFooterLink to="/services">Environmental Monitoring</StyledFooterLink>
          <StyledFooterLink to="/services">Custom AI Development</StyledFooterLink>
        </FooterColumn>
      </FooterContainer>

      <FooterBottom>
        © 2025 Genion Quantum Technologies. All rights reserved. |
        Advancing Science Through Innovation
      </FooterBottom>
    </FooterWrapper>
  );
}